module.exports = __webpack_public_path__ + "img/ad-home-xs.e53d9d20.jpg";